import { JobOfferShiftSource } from "@api/shared-runtime/enums";
import { calculateHours, calculateHoursDifference } from "./group-time-entries";

export const AD_HOC_ENTRY_LABEL = "Added by provider";
export const NOT_SCHEDULED_LABEL = "Not scheduled";
export const NO_DIFFERENCE_LABEL = "-";

interface ShiftSourceEntry {
  shiftSource: JobOfferShiftSource;
}

interface HoursDifferenceEntry extends ShiftSourceEntry {
  isOvertime: boolean;
  scheduledStartsAt: string | Date;
  scheduledEndsAt: string | Date;
  submittedStartsAt: string | Date;
  submittedEndsAt: string | Date;
}

/**
 * Ad-hoc entries are hours the provider logged for unscheduled work. Older ones
 * still have a job offer, so the shift source is the only reliable signal.
 */
export function isAdHocEntry(entry: ShiftSourceEntry): boolean {
  return entry.shiftSource === JobOfferShiftSource.ProviderRequested;
}

/**
 * Submitted hours minus scheduled hours, or null when there is no schedule to
 * compare against (ad-hoc entries store the submitted times as their schedule).
 */
export function getEntryHoursDifference(
  entry: HoursDifferenceEntry,
): number | null {
  if (isAdHocEntry(entry)) {
    return null;
  }

  const submittedStart = new Date(entry.submittedStartsAt);
  const submittedEnd = new Date(entry.submittedEndsAt);
  // For overtime entries, compare to 0 (no scheduled time for overtime)
  if (entry.isOvertime) {
    return calculateHours(submittedStart, submittedEnd);
  }
  return calculateHoursDifference(
    new Date(entry.scheduledStartsAt),
    new Date(entry.scheduledEndsAt),
    submittedStart,
    submittedEnd,
  );
}
